import styled from "styled-components";

const StyledAppIframeContent = styled.iframe`
    border: none;
    width: 100%;
    height: 100%;
    position: absolute;
    user-select: none;
`;

export default StyledAppIframeContent;